var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grey lighten-2", staticStyle: { "min-height": "100%" } },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-lg": "" } },
        [
          _c(
            "div",
            { staticClass: "text-xs-right" },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:opened", false)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.description || _vm.loadingHelp
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      !_vm.loadingHelp
                        ? _c(
                            "v-card",
                            {
                              staticClass: "grey--text text--darken-3",
                              attrs: { color: "white", flat: "" }
                            },
                            [
                              _c(
                                "v-card-title",
                                { attrs: { "primary-title": "" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "Medium" },
                                    [
                                      _c("v-icon", { attrs: { large: "" } }, [
                                        _vm._v("description")
                                      ]),
                                      _vm._v(
                                        "\n              Presentation\n            "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-card-text", [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.description)
                                      }
                                    })
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panel",
                                [
                                  _vm.lexique
                                    ? _c(
                                        "v-expansion-panel-content",
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [_vm._v(_vm._s(_vm.$t("lexique")))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass: "grey lighten-3"
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "grey lighten-3",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.lexique
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.video
                                    ? _c(
                                        "v-expansion-panel-content",
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [_vm._v("Video")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _vm.youtube === 0
                                                ? _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "grey lighten-3"
                                                    },
                                                    [
                                                      _c("video", {
                                                        staticStyle: {
                                                          width: "260px",
                                                          height: "auto",
                                                          left: "0px",
                                                          top: "0px"
                                                        },
                                                        attrs: {
                                                          controls: "",
                                                          alt: "presentation",
                                                          src: _vm.video,
                                                          poster:
                                                            _vm.videoposter,
                                                          playsinline: ""
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "grey lighten-3"
                                                    },
                                                    [
                                                      _c("iframe", {
                                                        staticStyle: {
                                                          width: "260px",
                                                          height: "auto",
                                                          left: "0px",
                                                          top: "0px"
                                                        },
                                                        attrs: {
                                                          src: _vm.video,
                                                          poster:
                                                            _vm.videoposter,
                                                          width: "260",
                                                          frameborder: "0",
                                                          allowfullscreen:
                                                            "allowfullscreen"
                                                        }
                                                      })
                                                    ]
                                                  )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "text-xs-center" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      indeterminate: "",
                                      size: 50,
                                      width: 1
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "grey--text text--darken-3",
                      attrs: { color: "white", flat: "" }
                    },
                    [
                      _c("v-card-title", [
                        _c(
                          "div",
                          { staticClass: "Medium" },
                          [
                            _c("v-icon", { attrs: { large: "" } }, [
                              _vm._v("book")
                            ]),
                            _vm._v(
                              " \n              " +
                                _vm._s(_vm.$t("knowledgeBase")) +
                                "\n            "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.supportAdress,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("ourKnowledgeBase")) +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _vm.emailSupportSend == true
                    ? _c(
                        "v-card",
                        {
                          staticClass: "grey--text text--darken-3",
                          attrs: { color: "white", flat: "" }
                        },
                        [
                          _c("v-card-title", [
                            _c(
                              "div",
                              { staticClass: "Medium" },
                              [
                                _c("v-icon", { attrs: { large: "" } }, [
                                  _vm._v("mail_outline")
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("contactTheSupport")) +
                                    "\n          "
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-card-text", { staticClass: "grey lighten-3" }, [
                            _vm._v(_vm._s(_vm.$t("emailSent")))
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emailSupportSend == false
                    ? _c(
                        "v-card",
                        {
                          staticClass: "grey--text text--darken-3",
                          attrs: { color: "white", flat: "" }
                        },
                        [
                          _c("v-card-title", [
                            _c(
                              "div",
                              { staticClass: "Medium" },
                              [
                                _c("v-icon", { attrs: { large: "" } }, [
                                  _vm._v("mail_outline")
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("contactTheSupport")) +
                                    "\n          "
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm._f("cap")(_vm.$t("subject"))
                                    },
                                    model: {
                                      value: _vm.subject,
                                      callback: function($$v) {
                                        _vm.subject = $$v
                                      },
                                      expression: "subject"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: {
                                      label: _vm._f("cap")(
                                        _vm.$t("typeYourMessage")
                                      ),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.message,
                                      callback: function($$v) {
                                        _vm.message = $$v
                                      },
                                      expression: "message"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        block: "",
                                        color: "primary",
                                        loading: _vm.loadingMail
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.send()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("send")) +
                                          "\n                "
                                      ),
                                      _c("v-icon", { attrs: { right: "" } }, [
                                        _vm._v("send")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "" } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d978675", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d978675","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzHelp.vue
// module id = null
// module chunks = 